// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2yjPS","subheader":"ReorderModal_subheader__1Cad7","listWrap":"ReorderModal_listWrap__1b5Io"};